import { render } from "./ContentAcordeon.vue?vue&type=template&id=4f09eb7c"
import script from "./ContentAcordeon.vue?vue&type=script&lang=js"
export * from "./ContentAcordeon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__